<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="80px" margin-top="0" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="速记码">
            <el-autocomplete
              v-model="zhxx.shortCode"
               style="width:100%"
              :trigger-on-focus="false"
              placeholder="请至少输入3个字符"
              :debounce="1000"
              :fetch-suggestions="queryShortCode"
              @select="selectShortCode"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="房产">
            <el-input
             style="width:100%"
              placeholder="请选择房产"
              v-model="zhxx.roomName"
              readonly
              @focus="showRoomSelect = true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="户主">
            <el-input  style="width:100%" placeholder="户主" v-model="query.householdName"></el-input>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="4">-->
        <!--          <el-form-item label="户主电话">-->
        <!--            <el-input placeholder="户主电话" v-model="query.linkPhone"></el-input>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->

        <el-col :span="6">
           <el-form-item label="收费周期" >
                     <el-date-picker
                     style="width:42%;"
                      v-model="query.billcycleNoStart"
                      type="month"
                      range-separator="至"
                        value-format="yyyyMM"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份">
                    </el-date-picker>
                    到
                    <el-date-picker
                    style="width:42%;"
                      v-model="query.billcycleNoEnd"
                      type="month"
                      range-separator="至"
                        value-format="yyyyMM"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份">
                    </el-date-picker>
                </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item label="开始月份" prop="billcycleNoStart">
            <el-date-picker
              v-model="query.billcycleNoStart"
              type="month"
              class="outo-width"
              value-format="yyyyMM"
              placeholder="开始月份"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="结束月份" prop="billcycleNoEnd">
            <el-date-picker
              v-model="query.billcycleNoEnd"
              type="month"
              class="outo-width"
              value-format="yyyyMM"
              placeholder="结束月份"
            >
            </el-date-picker>
          </el-form-item>
        </el-col> -->

      <el-col :span="6">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="全部" style="width: 100%;" clearable>
              <el-option
                v-for="item in allPayTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否付款" prop="payFlag">
            <el-select  style="width:100%" v-model="query.payFlag" placeholder="全部" clearable>
              <el-option style="padding-left: 10px;" value="1" label="是"></el-option>
              <el-option style="padding-left: 10px;" value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--        <el-col :span="8" v-show="payFlagShow">-->
        <!--          <el-form-item label="收费日期 从" prop="dateRange">-->
        <!--            <el-date-picker-->
        <!--              v-model="dateRange"-->
        <!--              type="daterange"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--              range-separator="到"-->
        <!--              start-placeholder="开始日期"-->
        <!--              end-placeholder="结束日期"-->
        <!--            >-->
        <!--            </el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->

        <el-col :span="12" style="text-align:right">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              native-type="submit"
              size="mini"
              @click.prevent="submitSearchForm"
              >搜索
            </el-button>
            <el-button size="mini" type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item label="应缴金额" prop="shouldAmountSum">
            <el-input :value="shouldAmountSum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="实收金额" prop="payAmountSum">
            <el-input :value="payAmountSum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="欠费金额" prop="arrearageAmountSum">
            <el-input :value="arrearageAmountSum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      title="选择房产"
      :visible.sync="showRoomSelect"
      width="30%"
      top="16vh"
      custom-class="room-select-dialog"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      center
      @close="showRoomSelect = false"
    >
      <RoomSelect @select="selectRoom"></RoomSelect>
      <span slot="footer">
        <el-button @click="showRoomSelect = false">取消</el-button>
        <el-button type="primary" @click="confirmRoom">确定</el-button>
      </span>
    </el-dialog>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <!--        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"-->
        <!--          >导 出-->
        <!--        </el-button>-->
      </template>
      <template slot="payFlagZh" slot-scope="scope">
        <el-tag v-if="scope.row.payFlag == 1">是</el-tag>
        <el-tag type="danger" v-if="scope.row.payFlag == 0">否</el-tag>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" icon="el-icon-view">查看</el-button>
        <el-button type="text" size="small" icon="el-icon-view">支付详情</el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getExcel, getPage, getAmount } from '@/api/v4ward/paybilllist/feepaybilllist';
import { mapGetters } from 'vuex';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import { getDictionary } from '@/api/common';
import RoomSelect from '@/components/room-select2';
import { loadZhxx } from '@/api/charge';

export default {
  components: { RoomSelect },
  data() {
    return {
      payFlagShow: false,
      showRoomSelect: false,
      zhxx: {
        shortCode: '',
      },
      temp: {},
      //页面初始化时该值为false，如果不是则是true
      propertyIsQuery: false,
      payAmountSum: '',
      shouldAmountSum: '',
      arrearageAmountSum: '',
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [],
      allSortTypeList: [],
      allFeeSortList: [],
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      propertyName: '',
      form: {},
      query: {
        shortCode: '',
        propertyId: '',
        payType: '',
        billStartDate: '',
        billcycleNoEnd: '',
        billcycleNoStart: '',
        timeRange:[]
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '房产',
            prop: 'roomName',
          },
          {
            label: '户主',
            prop: 'householdName',
          },
          // {
          //   label: '户主电话',
          //   prop: 'linkPhone',
          // },
          {
            label: '收费周期',
            prop: 'billcycleNo',
          },
          {
            label: '开始时间',
            prop: 'billStartDate',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '结束时间',
            prop: 'billEndDate',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '理论金额',
            prop: 'calAmount',
          },
          {
            label: '减免金额',
            prop: 'derateAmount',
          },
          {
            label: '抵扣金额',
            prop: 'accountpayAmount',
          },
          {
            label: '优惠金额',
            prop: 'couponAmount',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
          },
          {
            label: '费用种类',
            prop: 'feeSort',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
            dataType: 'number',
          },
          {
            label: '是否付款',
            prop: 'payFlagZh',
            slot: true,
          },
          {
            label: '收费人',
            prop: 'cashierName',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'query.payFlag'() {
      if (this.query.payFlag == 1) this.payFlagShow = true;
      else this.payFlagShow = false;
      console.log(this.allPayTypeList);
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initDefaultDateRange();
    this.initCurrentMonth();
    this.initSelectList();
  },
  mounted(){
    this.calcHeight()
  },
  methods: {
     calcHeight(){

      this.option.height = this.bodyHeight -435;
    },
    //查询速记码
    queryShortCode(qs, cb) {
      if (qs.length < 3) {
        cb();
        return;
      }
      loadZhxx({ shortCode: qs }).then(({ data }) => {
        if (this.vdui.isEmpty(data)) {
          cb();
          this.$message.info('未查询到住户信息');
        } else if (data.length === 1) {
          this.zhxx = data[0];
          this.query.propertyId = this.zhxx.roomId;
          cb([]);
        } else {
          this._.forEach(data, (item) => {
            item.value = item.shortCode;
          });
          cb(data);
        }
      });
    },
    //选择速记码
    selectShortCode(item) {
      this.queryZhxx({ shortCode: item.shortCode });
    },
    //查询住户信息
    queryZhxx(params) {
      loadZhxx(params).then(({ data }) => {
        this.zhxx = data[0];
        this.query.propertyId = this.zhxx.roomId;
      });
    },
    //选择房产
    selectRoom(item) {
      console.log(item.roomId);
      this.temp.roomId = item.roomId;
    },
    //确认选定房产
    confirmRoom() {
      this.showRoomSelect = false;
      if (this.temp.roomId) {
        this.zhxx.roomId = this.temp.roomId;
        this.queryZhxx({ roomId: this.zhxx.roomId });
      }
    },
    ///////////////

    // cellStyle({ row, column, rowIndex, columnIndex }) {
    //   if (row.payFlag == 0) {
    //     return {
    //       color: 'red',
    //     };
    //   }
    // },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.propertyIsQuery = false;
      this.query.payType=''
      this.query.timeRange=[]
      this.query.payFlag=''
      this.zhxx = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      this.page.currentPage = 1
     
      this.searchChange(this.query);
    },
    onLoad(page) {
      // if (this.query.payFlag == 1) {
      //   this.query.dateFrom = this.dateRange[0] + ' 00:00:00.000';
      //   this.query.dateTo = this.dateRange[1] + ' 23:59:59.999';
      // } else {
      //   this.query.dateFrom = '';
      //   this.query.dateTo = '';
      //   this.query.payType = '';
      // }
      // if (this.propertyIsQuery && !this.query.propertyId) {
      //   if (this.allPropertyListCopy.length > 0) {
      //     this.query.propertyId = this.allPropertyListCopy[0].id;
      //   } else {
      //     this.$message.error('未查询到任何小区，请重新输入速记码!');
      //     return;
      //   }
      // }

      page = page || this.page;
      this.loading = true;
      if (!this.propertyIsQuery) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          this.zhxx.roomName = data.data[0].roomName;
          this.zhxx.shortCode = data.data[0].shortCode;
          this.initCurrentMonth();

          getPage(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipage.total;
            this.data = data.ipage.records;
            this.loading = false;
            this.selectionClear();
          });
          this.getAmount();
        });
        this.propertyIsQuery = true;
        return;
      }
      getPage(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.ipage.total;
          this.data = data.ipage.records;
          this.loading = false;
          this.selectionClear();
        }
      );
      this.getAmount();
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    getAmount: function () {
      getAmount(Object.assign(this.query)).then(({ data }) => {
        this.shouldAmountSum = data.shouldAmountSum;
        this.payAmountSum = data.payAmountSum;
        this.arrearageAmountSum = data.arrearageAmountSum;
      });
    },

    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
    },
    initCurrentMonth: function () {
      // var date = new Date();
      // date.setDate(1);
      // var month = parseInt(date.getMonth() + 1);
      // if (month < 10) {
      //   month = '0' + month;
      // }
      // this.query.billcycleNoEnd = `${date.getFullYear()}${month}`;
      // this.query.billcycleNoStart = `${date.getFullYear()}${month}`;
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initSelectList: function () {
      // getDictionary('fee_sort').then((data) => {
      //   this.allFeeSortList = data.data;
      // });
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        getExcel(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '房产',
              '户主',
              '户主电话',
              '收费周期',
              '开始时间',
              '结束时间',
              '理论金额',
              '减免金额',
              '抵扣金额',
              '优惠金额',
              '应收金额',
              '收费金额',
              '费用种类',
              '是否付款',
              '收费人',
              '支付方式',
              '收费时间',
            ]; // 导出excel 的标题
            const filterVal = [
              'roomName',
              'householdName',
              'linkPhone',
              'billcycleNo',
              'billStartDate',
              'billEndDate',
              'calAmount',
              'derateAmount',
              'accountpayAmount',
              'couponAmount',
              'shouldAmount',
              'payAmount',
              'feeSort',
              'payFlag',
              'cashierName',
              'payType',
              'payTime',
            ]; // 每个标题对应的字段

            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                roomName: item.roomName,
                householdName: item.householdName,
                linkPhone: item.linkPhone,
                billcycleNo: item.billcycleNo,
                billStartDate: item.billStartDate
                  ? this.dayjs(item.billStartDate).format('YYYY-MM-DD HH:mm:ss')
                  : '',
                billEndDate: item.billEndDate
                  ? this.dayjs(item.billEndDate).format('YYYY-MM-DD HH:mm:ss')
                  : '',
                calAmount: item.calAmount,
                derateAmount: item.derateAmount,
                accountpayAmount: item.accountpayAmount,
                couponAmount: item.couponAmount,
                shouldAmount: item.shouldAmount,
                payAmount: item.payAmount,
                feeSort: this.feeSortName(item.feeSort),
                payFlag: this.payFlagNameShow(item.payFlag),
                cashierName: item.cashierName,
                payType: this.payTypeToPayTypeName(item.payType),
                payTime: item.payTime ? this.dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss') : '',
              };
            });

            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '物业账单查询' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
    feeSortName(feeSort) {
      var feeSortName = '';
      this.allFeeSortList.forEach(function (value, index, array) {
        if (value.dictKey == feeSort) {
          feeSortName = value.dictValue;
          return;
        }
      });
      return feeSortName;
    },
    payFlagNameShow(payFlag) {
      if (payFlag == 1) return '是';
      else if (payFlag == 0) return '否';
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}

.el-dialog__body .el-card__body {
  padding: 0;
}

.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: red;
}

.el-date-editor.el-input {
  width: 100%;
}
</style>
